import React from 'react';

export const DropDown = <T,>({
  classNames: {
    container: getContainerClassName = (s: string): string => s,
    dropdownIcon: getDropdownClassName = (s: string): string => s,
    select: getSelectClassName = (s: string): string => s,
  },
  setState,
  fromString,
  toLabel,
  state,
  states,
  toString_,
  dropdownIcon,
  style,
}: {
  state: T;
  states: T[];
  setState: (arg: ((prevValue: T) => T) | T) => void;
  toString_: (value: T) => string;
  fromString: (str: string) => { tag: 'Just'; value: T } | { tag: 'Nothing' };
  toLabel: (value: T) => string;
  dropdownIcon: string;
  classNames: {
    container?: (defaultClassName: string) => string;
    dropdownIcon?: (defaultClassName: string) => string;
    select?: (defaultClassName: string) => string;
  };
  style?: React.CSSProperties;
}): React.ReactElement => {
  const selectRef = React.useRef<HTMLSelectElement>(null);
  return (
    <>
      <div
        className={getContainerClassName(
          `h-10 rounded-lg border-bluegray-400 border relative flex flex-row items-center bg-white overflow-hidden`
        )}
        onClick={(): void => {
          selectRef.current && selectRef.current.click();
        }}
        style={style}>
        <select
          className={getSelectClassName(
            `w-full h-full appearance-none bg-transparent cursor-pointer`
          )}
          ref={selectRef}
          value={toString_(state)}
          onChange={(e): void => {
            const result = fromString(e.currentTarget.value);
            switch (result.tag) {
              case 'Just':
                setState(result.value);
                break;
              case 'Nothing':
                break;
            }
          }}>
          {states.map((s, i) => {
            return (
              <option key={i} value={toString_(s)}>
                {toLabel(s)}
              </option>
            );
          })}
        </select>
        <div
          className={getDropdownClassName(
            `mr-1 text-bluegray-400 pointer-events-none icon-${dropdownIcon}`
          )}></div>
      </div>
    </>
  );
};
